var _circle, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#1C2335",
    fillOpacity: 0.03
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 34.25,
    stroke: "#787E8B",
    strokeOpacity: 0.2,
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.87 35.0081L46.6205 25.2552C47.1265 24.749 47.1265 23.9227 46.6205 23.3898C46.1144 22.8568 45.2884 22.8836 44.7555 23.3898L35.0051 33.1433L25.2546 23.3903C24.7485 22.8841 23.9225 22.8841 23.3897 23.3903C22.8568 23.8965 22.8836 24.7227 23.3897 25.2557L33.1401 35.0087L23.3897 44.7616C22.8836 45.2678 22.8836 46.094 23.3897 46.627C23.656 46.8934 23.9757 47 24.322 47C24.6683 47 24.9881 46.8668 25.2544 46.627L35.0048 36.8741L44.7553 46.627C45.0216 46.8934 45.3414 47 45.6877 47C46.034 47 46.3537 46.8668 46.62 46.627C47.1261 46.1208 47.1261 45.2946 46.62 44.7616L36.87 35.0081Z",
    fill: "#1C2335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8bba6bf1382c59fac4f329863fad105b.svg";
export { ForwardRef as ReactComponent };